// Nazwa pliku: MonthYearInput.js
// Autor: Centrum Informatyki Zeto SA
import React, {useEffect} from "react";
import { InputGroup, Form } from "react-bootstrap";
import { getObjectNestedProperty } from "wup-module1-base/src/helpers";

/**
 * Kontrolka wprowadzania jednolinijkowych tekstów
 * @param {string} id Identyfikator kontrolki
 * @param {string} label Etykieta kontrolki
 * @param {string} placeholder Placeholder kontrolki
 * @param {function} onChange Zmiana wartości
 * @param {bool} readOnly Czy wartość tylko do odczytu
 * @param {object} refs Referencja do walidacji
 * @param {object} errors Błędy walidacji
 * @param {object} value Wartość kontrolki
 * @param {string} className Klasy CSS dodane do kontrolki
 * @param {string} type Typ kontrolki
 * @param {bool} hidden Czy pole jest ukryte
 * @param {bool} hiddenLabel Czy etykieta jest ukryta
 * @param {string} defaultValue Wartość domyślna
 * @param {ReactNode} icon Ikonka
 * @param {ReactNode} button Przycisk dodany na końcu kontrolki
 */
const MonthYearInput = ({
  id,
  label,
  placeholder = "RRRR-MM",
  onChange,
  readOnly,
  refs,
  errors,
  value,
  className = "",
  type = "text",
  hidden = false,
  hiddenLabel = false,
  defaultValue,
  setTableTrigger,
  icon,
  button,
  ...props
}) => {
    const change = (e) => {
        let inputValue = e.target.value.trimStart();
    
        const pattern = /^\d{0,4}(-\d{0,2})?$/;
        if (!pattern.test(inputValue)) {
            inputValue = inputValue.slice(0, -1);
        }
    
        if (inputValue.length === 4 && !inputValue.includes("-")) {
            inputValue += "-";
        }
    
        const parts = inputValue.split("-");
    
        if (parts[0].length > 4) {
            parts[0] = parts[0].slice(0, 4);
        }
    
        if (parts.length === 2) {
            let monthPart = parts[1].slice(0, 2);
            parts[1] = monthPart;
            let month = parseInt(monthPart, 10);
            
            if (month > 12) {
                parts[1] = 12;
            }
        }
    
        inputValue = parts.join("-");
    
        e.target.value = inputValue;
    
        if (onChange) onChange(inputValue);
    
        refs?.onChange(e);
    };
    
  const blur = (e) => {
    let inputValue = e.target.value.trimStart();
    
    const pattern = /^\d{0,4}(-\d{0,2})?$/;
    if (!pattern.test(inputValue)) {
        inputValue = inputValue.slice(0, -1);
    }

    const parts = inputValue.split("-");

    if (parts[0].length > 4) {
        parts[0] = parts[0].slice(0, 4);
    }

    if (parts.length === 2) {
        let monthPart = parts[1].slice(0, 2);
        let month = parseInt(monthPart, 10);

        if (isNaN(month)) {
            month = 1;
        } else if (month < 1) {
            month = 1;
        } else if (month > 12) {
            month = 12;
        }

        parts[1] = month.toString().padStart(2, "0");
    }

    inputValue = parts.join("-");
    e.target.value = inputValue;

    if (onChange) onChange(e.target.value);
    refs?.onChange(e);
  };

  return (<>
      {errors && (
 <Form.Group controlId={id}>
 {label && (
   <Form.Label
     className={[
       getObjectNestedProperty(errors, id) && "color-danger",
       (hidden || hiddenLabel) && "sr-only",
     ].join(" ")}
   >
     {label}
   </Form.Label>
 )}
 <InputGroup hasValidation={getObjectNestedProperty(errors, id)}>
   <Form.Control
     className={`${className}${
       (getObjectNestedProperty(errors, id) && " border-red is-invalid") ??
       ""
     }`}
     type={hidden ? "hidden" : type}
     placeholder={placeholder}
     value={value}
     readOnly={readOnly}
     defaultValue={defaultValue}
     {...refs}
     onChange={change}
     onBlur={blur}
     {...props}
   />
   {icon && (
     <InputGroup.Text className={className}>{icon}</InputGroup.Text>
   )}
   {button && <InputGroup.Append>{button}</InputGroup.Append>}
   {getObjectNestedProperty(errors, id) && (
     <Form.Control.Feedback type="invalid" className="fs-1rem">
       {getObjectNestedProperty(errors, id).message}
     </Form.Control.Feedback>
   )}
 </InputGroup>
</Form.Group>
)}
  </>
  );
};

export default MonthYearInput;
